import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPerfomanceActive = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 14,
	height: 14,
	viewBox: "0 0 14 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M4.62574 0.320091C6.08199 -0.14821 7.65499 -0.101467 9.08086 0.452479C10.6797 1.07362 12.065 2.15234 12.8809 4.25248C13.4348 5.67835 13.4816 7.25135 13.0133 8.7076C12.545 10.1639 11.5901 11.4148 10.3089 12.2505C9.02763 13.0862 7.49798 13.4559 5.9765 13.2975C4.45503 13.1391 3.03429 12.4624 1.95263 11.3807C0.870973 10.2991 0.194196 8.87832 0.0358323 7.35684C-0.122531 5.83537 0.247153 4.30571 1.08287 3.02448C1.91859 1.74325 3.16949 0.788393 4.62574 0.320091Z",
			fill: "#2667FF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.68099 7.98503C7.41737 7.98503 8.01432 7.38807 8.01432 6.65169C8.01432 5.91531 7.41737 5.31836 6.68099 5.31836C5.94461 5.31836 5.34766 5.91531 5.34766 6.65169C5.34766 7.38807 5.94461 7.98503 6.68099 7.98503Z",
			fill: "white",
			stroke: "white",
			strokeWidth: 1.2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.61328 5.71966L9.67969 3.6543",
			stroke: "white",
			strokeWidth: 1.2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgPerfomanceActive;
